export default "__VITE_ASSET__iLk2Bypg__"